import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { adminEnvelopeLeft } from "../../../../services/AdminService";

function AdminClientEnvelopeUpgrade() {
    let { client } = useParams();

    const [totalEnvelope, setTotalEnvelope] = useState(0);
    const [planName, setPlanName] = useState('Free Trial');

    useEffect(function () {
        adminEnvelopeLeft({ client_id: client })
            .then(response => {
                setPlanName(response.data.data.plan_name);
                setTotalEnvelope(response.data.data.total_envelope);
            })
            .catch(err => {

            });
    }, [client]);

    return (
        <>
            <div className="card_content d-flex flex-column justify-content-between">
                {/* <div className="d-flex align-items-center justify-content-end"> */}
                <h2 className="mb-3 text-black"><span className="text-primary">{totalEnvelope} Sleeves </span>Left for {planName}</h2>
                <NavLink to={"/billing/pricing"} className="upgrade mt-3 text-decoration-none">Upgrade</NavLink>
                {/* </div> */}
            </div>
     
        </>
    );
}

export default AdminClientEnvelopeUpgrade;